export default {
  login: {
    title: 'QuBit Affiliate',
    subtitle: '歡迎註冊 QuBit Affiliate',
    accountLogin: '帳號登入',
    mobileLogin: '手機登入',
    qrCodeLogin: '二維碼登入',
    register: '註冊',
    scanQRCodeTip: '請使用手機掃描二維碼登入',
    backToLogin: '返回登入',
    mobilePlaceholder: '手機號',
    qrCodePlaceholder: '二維碼',
    smsPlaceholder: '簡訊驗證碼',
    verificationCodePlaceholder: '驗證碼',
    mobileRequired: '請輸入手機號',
    qrCodeRequired: '請掃描二維碼',
    smsRequired: '請輸入簡訊驗證碼',
    sendCode: '發送驗證碼',
    scanQrcode: '掃描二維碼',
    usernamePlaceholder: '使用者名稱/電子郵件',
    passwordPlaceholder: '請輸入密碼',
    captchaPlaceholder: '請輸入驗證碼',
    usernameRequired: '請輸入使用者名稱/手機號',
    passwordRequired: '請輸入密碼',
    captchaRequired: '請輸入驗證碼',
    captchaMismatch: '錯誤的驗證代碼',
    captchaError: '驗證碼錯誤',
    rememberMe: '7天內免登入',
    forgotPassword: '忘記密碼？',
    loginButton: '登入',
    loginSuccess: '登入成功！',
    loginFailed: '登入失敗，請檢查使用者名稱和密碼！',
    emailSent: '驗證碼已發送',
    processingToken: '登入中...',
  },
  common: {
    theme: {
      light: '淺色模式',
      dark: '深色模式'
    },
    language: {
      zh: '簡體中文',
      en: 'English',
      zhTW: '繁體中文'
    },
    actions: {
      expand: '展開',
      collapse: '收起',
      view: '查看',
      edit: '編輯',
      delete: '刪除',
      create: '創建',
      save: '儲存',
      cancel: '取消',
      confirm: '確認',
      reset: '重設',
      search: '搜尋',
      export: '匯出',
      import: '匯入'
    },
    notification: '通知',
    search: '搜尋',
    fullscreen: '全螢幕顯示',
    exitFullscreen: '退出全螢幕',
    languageSwitch: '切換語言',
    settings: '系統設定',
    yes: '確定',
    no: '取消',
    edit:'編輯',
    delete:'刪除',
    create: '創造',
    cancel: '取消',
    save: '儲存',
    export: '匯出',
    unknown: '未知',
    and: '和',
    validation: {
      walletAddressError: '請輸入數字ID。',
      numericOnlyError: '該欄位只能包含數字。'
    }
  },
  messages: {
    error: {
      networkError: '網路錯誤，請稍後重試',
      serverError: '伺服器錯誤，請稍後重試'
    }
  },
  register: {
    subtitle: '歡迎註冊 QuBit Affiliate',
    usernamePlaceholder: '請輸入使用者名稱',
    mobilePlaceholder: '請輸入手機號',
    smsPlaceholder: '請輸入簡訊驗證碼',
    emailPlaceholder: '電子郵件',
    emailCodePlaceholder: '驗證碼',
    invalidEmail: '無效信箱',
    passwordPlaceholder: '請輸入密碼',
    confirmPasswordPlaceholder: '請確認密碼',
    usernameRequired: '請輸入使用者名稱',
    mobileRequired: '請輸入手機號',
    smsRequired: '請輸入簡訊驗證碼',
    emailRequired: '請輸入您的電子郵件',
    codeRequired: '請輸入驗證碼',
    passwordRequired: '請輸入密碼',
    confirmPasswordRequired: '請確認密碼',
    passwordMinLength: '密碼長度不能小於6位',
    passwordNotMatch: '兩次輸入的密碼不一致',
    agreement: '我已閱讀並同意',
    agreementLink: '《使用者協議》',
    termLink: '《使用條款》',
    privacyLink: '《隱私政策》',
    agreementRequired: '請閱讀並同意使用者協議。',
    cookiesPolicy: '本網站使用 cookies 以確保最佳使用者體驗。這些 cookies 是嚴格必要的或對最佳功能至關重要的。使用本網站即表示您同意 cookies 政策。',
    sendCode: '發送驗證碼',
    smsSent: '驗證碼已發送',
    smsFailed: '驗證碼發送失敗',
    emailSent: '驗證碼已發送',
    emailFailed: '發送驗證碼失敗',
    submit: '註冊',
    success: '註冊成功',
    failed: '註冊失敗',
    backToLogin: '返回登入',
    inviteCodePlaceholder: '輸入邀請碼',
    inviteCodeRequired: '需要邀請碼',
    inviteCodeMaxLength: '邀請代碼必須少於 6 個字元。',
    passwordRules: {
      minLength: '密碼長度不能少於 8 位',
      maxLength: '密碼長度不能超過 20 位',
      requireNumber: '密碼必須包含數字',
      requireLower: '密碼必須包含小寫字母',
      requireUpper: '密碼必須包含大寫字母',
      requireSpecial: '密碼必須包含特殊字元'
    },
    passwordStrength: {
      veryWeak: '極弱',
      weak: '弱',
      medium: '中等',
      strong: '強',
      veryStrong: '極強'
    },
    passwordRequirements: {
      title: '密碼要求',
      length: '長度在 8-20 個字元之間',
      number: '必須包含數字',
      upper: '必須包含大寫字母',
      lower: '必須包含小寫字母',
      special: '必須包含特殊字元'
    }
  },
  reset: {
    subtitle: '重設您的密碼',
    mobilePlaceholder: '請輸入手機號',
    smsPlaceholder: '請輸入簡訊驗證碼',
    newPasswordPlaceholder: '請輸入新密碼',
    confirmPasswordPlaceholder: '請確認新密碼',
    mobileRequired: '請輸入手機號',
    smsRequired: '請輸入簡訊驗證碼',
    newPasswordRequired: '請輸入新密碼',
    confirmPasswordRequired: '請確認新密碼',
    passwordMinLength: '密碼長度不能小於6位',
    passwordNotMatch: '兩次輸入的密碼不一致',
    sendCode: '發送驗證碼',
    smsSent: '驗證碼已發送',
    smsFailed: '驗證碼發送失敗',
    submit: '重設密碼',
    success: '密碼重設成功',
    failed: '密碼重設失敗',
    backToLogin: '返回登入'
  },
  profile: {
    basicInfo: '基本資訊',
    security: '安全設定',
    activity: '帳號動態',
    notification: '通知設定',
    apiAccess: 'API 存取',
    username: '使用者名稱',
    email: '信箱',
    mobile: '手機號',
    gender: '性別',
    genderOptions: {
      male: '男',
      female: '女',
      other: '其他'
    },
    birthday: '生日',
    location: '所在地',
    bio: '個人簡介',
    company: '公司',
    position: '職位',
    website: '個人網站',
    uploadAvatar: '上傳頭像',
    cropAvatar: '裁剪頭像',
    avatarTypeError: '只能上傳 JPG/PNG 格式的圖片',
    avatarSizeError: '圖片大小不能超過 2MB',
    avatarUpdateSuccess: '頭像更新成功',
    avatarUpdateFailed: '頭像更新失敗',
    save: '儲存',
    validation: {
      usernameRequired: '請輸入使用者名稱',
      usernameFormat: '使用者名稱只能包含字母、數字、底線，長度 3-20 位',
      emailRequired: '請輸入信箱',
      emailFormat: '請輸入正確的信箱格式',
      mobileRequired: '請輸入手機號',
      mobileFormat: '請輸入正確的手機號格式',
      bioMaxLength: '個人簡介不能超過 200 字',
      websiteFormat: '請輸入正確的網址格式'
    },
    oldPassword: '原密碼',
    newPassword: '新密碼',
    confirmPassword: '確認密碼',
    changePassword: '修改密碼',
    updateSuccess: '更新成功',
    updateFailed: '更新失敗',
    passwordChanged: '密碼修改成功',
    passwordChangeFailed: '密碼修改失敗',
    invalidMobile: '請輸入正確的手機號',
    twoFactor: '兩步驗證',
    loginDevices: '登入設備',
    notificationSettings: '通知設定',
    loginHistory: '登入歷史',
    operationLog: '操作記錄',
    apiTokens: 'API 令牌',
    webhooks: 'Webhook 設定',
    loginDays: '登入天數',
    lastActive: '最近活躍',
    deviceInfo: {
      browser: '瀏覽器',
      os: '作業系統',
      ip: 'IP 位址',
      location: '登入地點',
      time: '登入時間',
      current: '當前設備',
      lastActive: '最後活躍',
      revokeAccess: '撤銷存取',
      revokeConfirm: '確定要撤銷此設備的存取權限嗎？'
    },
    notificationTypes: {
      all: '所有通知',
      system: '系統通知',
      security: '安全通知',
      activity: '活動通知'
    },
    apiTokenSettings: {
      create: '創建令牌',
      name: '令牌名稱',
      token: '令牌',
      permissions: '權限',
      expiresAt: '到期時間',
      lastUsed: '最後使用',
      created: '創建時間',
      status: '狀態',
      active: '生效中',
      expired: '已過期',
      revoked: '已撤銷'
    },
    webhookSettings: {
      create: '創建 Webhook',
      url: '回呼 URL',
      secret: '密鑰',
      events: '事件類型',
      status: '狀態',
      lastDelivery: '最後推送',
      deliveryStatus: '推送狀態'
    }
  },
  user: {
    profile: '個人資訊',
    logout: '退出登入',
    defaultName: '使用者',
    actions: {
      notification: {
        title: '通知中心',
        unread: '{count} 條未讀訊息'
      },
      search: {
        title: '全域搜尋',
        placeholder: '搜尋...'
      },
      settings: {
        title: '系統設定',
        theme: '主題設定',
        language: '語言設定',
        other: '其他設定'
      }
    }
  },
  route: {
    home: '首頁',

    dataAnalysis: '資料分析',
    'dataAnalysis.dataOverview': '資料概覽',
    'dataAnalysis.dailyDataAnalysis': '每日資料分析',

    customerManagement: '客戶管理',
    'customerManagement.clientList': '客戶列表',
    'customerManagement.clientGrouping': '客戶分組',
    'customerManagement.superAgentSystem': '超級代理商體系',
    'customerManagement.operationRecord': '操作記錄',

    invitationPromotion: '邀請推廣',
    'invitationPromotion.invitationLink': '邀請連結',
    'invitationPromotion.customRegistrationPage': '自訂註冊頁',
    'invitationPromotion.invitationReviewRecord': '操作記錄',

    financialDetails: '財務明細',
    'financialDetails.commission': '傭金明細',
    'financialDetails.transaction': '交易明細',
    'financialDetails.daily': '每日資料彙總',

    supportCenter: '支援中心',
    'supportCenter.materialLibrary': '素材庫管理',
    'supportCenter.helpCenter': '幫助中心',

    activityCenter: '活動中心',

    overview: '概覽',

    system: '系統管理',
    'system.user': '使用者管理',
    'system.role': '角色管理',
    'system.menu': '選單管理',
    'system.dept': '部門管理',
    
    network: '網路請求',
    'network.basic': '基礎網路',
    'network.advanced': '高級網路',
    
    profile: '個人頁',
    'profile.basic': '基礎詳情頁',
    'profile.advanced': '高級詳情頁',
    
    error: '錯誤頁',
    'error.403': '403',
    'error.404': '404',
    'error.500': '500',
    auth: '認證頁',
    'auth.login': '登入',
    'auth.register': '註冊',
    'dataChart': '資料圖表',
    'chart': '資料表格',
  },
  network:{
    'network-error': '網路錯誤，請檢查網路連線',
    'bad-request': '400 請求參數錯誤',
    'unauthorized': '401 帳號密碼錯誤，請重新登入',
    'forbidden': '403 拒絕訪問',
    'not-found': '404 請求錯誤，未找到該資源',
    'internal-error': '500 伺服器錯誤',
    'request-canceled-or-timeout': '請求已取消或逾時'
  },
  apiError: {
    '1001': '系統繁忙',
    '1002': '服務暫時不可用',
    '1003': '請求參數錯誤',
    '1004': '簽名驗證失敗',
    '1005': '請求時間異常',
    '1006': '無效操作，請重新整理頁面重試',
    '1007': '未找到數據',
    '1008': '資料庫出錯',
    '1009': '驗證碼錯誤',
    '1010': '驗證碼失效，請重新獲取',
    '1011': '圖形驗證碼錯誤',
    '1012': '請求頻繁',
    '1013': '操作逾時，請重試',
    '1014': '時間區間不支援，最大支援七天',
    '1015': '最多匯出 3 週數據',
    '1101': '禁止登入',
    '1102': '用戶名或密碼不正確',
    '1103': '當前用戶僅限密碼登入',
    '1104': '需要綁定 Google 驗證器',
    '1105': '無效的驗證器驗證碼',
    '1106': '用戶不存在',
    '1107': '需要進行兩步驗證',
    '1108': '暫無權限，請修改密碼後訪問',
    '1109': '無權訪問',
    '1110': '用戶狀態錯誤',
    '1111': '目標用戶是被操作用戶下級，無法進行移動',
    '1112': '其他用戶正在進行用戶移動或代理添加操作，請稍後再試',
    '1113': '該 ID 無效或用戶 ID 不是下屬',
    '1114': '返佣比例超出限制',
    '1115': '登入過期',
    '1116': '正在進行返佣清算，請稍後再試',
    '1117': '請求參數重複',
    '1118': '無法降低返利比例',
    '1119': '無效的 Token',
    '1120': '返佣比例不能低於或等於普通用戶比例',
  },
  overview: {
    title: '資料概覽',
    dataUpdatedAt: '資料更新於：{time}（UTC+8 時區）',
    overview: '資料概覽',
    totalCommission: '總傭金(USDT)',
    totalCommissionTooltip: '總傭金',
    time: '時間',
    month: '月份',
    customer: '客戶數量',
    selfRebate: '自返傭',
    netFee: '淨手續費',
    totalVolume: '總交易量(USDT)', 
    customerCount: '客戶數(人)',
    comparison: '環比',
    hello: '您好,{name} !',
    spot: '現貨',
    futures: '合約',
    alpha: 'Alpha',
    pendingWithdraw: '待提取',
    withdraw: '提現',
    claim: '認領',
    customerActivity: '客戶活躍度',
    activeUsers: '每日活躍人數',
    inactiveUsers: '非活躍人數',
    myReferralLinks: '我的推廣連結',
    inviteCode: '邀請碼',
    inviteeCount: '邀請人數',
    spotRebateRate: '現貨返傭比例',
    futuresRebateRate: '合約返傭比例',
    alphaRebateRate: 'Alpha 返傭比例',
    operation: '操作',
    myCommission: '我的',
    customerCommission: '客戶',
    defaultLink: '預設連結',
    shareLink: '分享連結',
    recentRegistrations: '最近註冊',
    userUID: '使用者UID',
    registrationTime: '註冊時間',
    isDeposited: '是否已入金',
    isActive: '是否活躍',
    yes: '是',
    no: '否',
    notifications: {
      userReward: '使用者***{id}***獲得{amount}USDT獎金'
    },
    noInviteCode: '暫無邀請碼',
    noRecentRegistrations: '暫無最近註冊資料',
    errorLoadingData: '載入資料時出錯：',
    claimError: '認領傭金時出錯',
    loadingOverviewData: '載入概覽資料中...',
    loadingRecentRegistrations: '載入最近註冊資料中...',
    codeCopied: '邀請碼已複製到剪貼簿',
    linkCopied: '推薦連結已複製到剪貼簿',
  },
  dataAnalysis: {
    dataOverview: {
      title: '返傭明細',
      dataUpdatedAt: '資料更新於：{time}（UTC+8 時區）',
      productLine: '產品線',
      subAgentUID: '子代理UID',
      pleaseEnterPlaceholder: '請輸入',
      invitationCode: '邀請碼',
      transactionTime: '交易時間',
      startTime: '開始時間',
      endTime: '結束時間',
      export: '匯出',
      reset: '重設',
      query: '查詢',
      all: '全部',
      futures: '合約交易',
      spot: '現貨交易',
      none: '無',
      of: '共',
      items: '項',
      table: {
        subAgentContributionRanking: '子代理貢獻排名',
        invitationCodeContributionRanking: '邀請碼貢獻排名',
        rank: '排名',
        subAgentUID: '子代理UID',
        contributionCommission: '貢獻傭金 (USDT)',
        transactionAmount: '交易金額 (USDT)',
        invitationCode: '邀請碼',
        registrationsCount: '註冊人數'
      },
      line: {
        title: '資料趨勢分析',
        commission: '傭金',
        totalTransactionVolume: '總交易量',
        numberOfInvitees: '邀請人數',
        numberOfDeposits: '入金人數',
        newUserTrend: '新增使用者趨勢',
        commissionTrend: '傭金趨勢'
      }
    },
    dailyDataAnalysis: {
      title: '每日資料分析',
      productLine: '產品線',
      transactionTime: '交易時間',
      startTime: '開始時間',
      endTime: '結束時間',
      reset: '重設',
      query: '查詢',
      all: '全部',
      futures: '合約交易',
      spot: '現貨交易',
      of: '共',
      items: '項',
      none: '無',
      table: {
        date: '日期',
        newUsers: '新增使用者',
        activeUsers: '活躍使用者',
        totalDeposits: '總入金',
        totalTradingVolume: '總交易量',
        totalFees: '總手續費',
        totalCommission: '總傭金'
      }
    }
  },
  customerManagement: {
    clientList: {
      title: '客戶列表',
      dataUpdatedAt: '資料更新於：{time}（UTC+8 時區）',
      customerDetails: '客戶詳情',
      customerUID: '客戶UID',
      customerEmail: '電子郵件 / 錢包地址',
      pleaseEnterPlaceholder: '請輸入',
      customerGroup: '客戶分組',
      customerType: '客戶類型',
      transactionTime: '交易時間',
      startTime: '開始時間',
      endTime: '結束時間',
      reset: '重設',
      query: '查詢',
      all: '全部',
      superiorAgent: '上級超級代理商',
      clientListTable: '客戶列表',
      totalRecords: '條記錄',
      selected: '已選擇',
      of: '共',
      items: '項',
      none: '無',
      direct: '直接',
      indirect: '間接',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      addAgentError: '添加代理時出錯。',
      manageError: '管理客戶時出錯。',
      remarkError: '編輯備註時出錯。',
      detailsError: '獲取詳情時出錯。',
      historyError: '獲取歷史時出錯。',
      entrustType: {
        market: '市價單',
        limit: '計劃單',
        liquidation: '強平單'
      },
      orderType: {
        marketOrder: '市價單',
        planOrder: '計劃單',
        takeProfitOrder: '止盈單',
        stopLossOrder: '止損單',
        forcedLiquidationOrder: '強平單'
      },
      direction: {
        buy: '買入',
        sell: '賣出'
      },
      role: {
        maker: '掛單方',
        taker: '吃單方'
      },
      status: {
        default: '預設',
        userRevocation: '用戶撤銷',
        marketUnfilledRevocation: '市價未成交撤銷',
        backgroundRevocation: '後台撤銷',
        full: '全部成交',
        partialRetracted: '部分成交已撤',
        partialSlot: '部分成交'
      },
      table: {
        uid: 'UID',
        label: '備註',
        registrationTime: '註冊時間',
        customerType: '客戶類型',
        superiorAgentUID: '上級代理UID',
        username: '使用者名稱',
        tradingVolume: '交易量 (USDT)',
        handlingFee: '手續費 (USDT)',
        commissions: '傭金 (USDT)',
        deposit: '入金 (USDT)',
        associatedGroup: '關聯分組',
        assetRange: '資產範圍 (USDT)',
        firstDepositTime: '首次入金時間',
        firstLastTransactionTime: '首次/最後交易時間',
        firstTransactionTime: '首次交易時間',
        lastTransactionTime: '最後交易時間',
        operation: '操作',
        view: '查看',
        manage: '管理',
        history: '歷史委託',
        futures: '合約',
        spot: '現貨',
        transactionUID: '交易 UID',
        transactionMethod: '交易方式',
        tradingPair: '交易對',
        direction: '方向',
        subjectiveMethod: '主觀方式',
        averageTransactionPrice: '成交均價',
        executedOrderedVolume: '已成交/委託量',
        transactionFee: '手續費',
        orderStatus: '訂單狀態',
        creationTime: '創建時間',
        addAgent: '添加代理',
        remark: '備註',
        active: '活躍',
        inactive: '非活躍',
        registrationTimeTooltip: '活躍：最近7天內有交易。非活躍：最近7天內無交易。'
      },
      manage: {
        title: '管理客戶',
        clientUID: '客戶UID',
        clientLabel: '客戶標註',
        clientLabelPlaceholder: '請輸入標註',
        commissionSettings: '設定返傭比例',
        spot: '現貨',
        futures: '合約',
        clientRatio: '客戶的比例',
        myRatio: '我的的比例',
        modifyNote: '注意：初始傭金比例的更改將使該客戶成為您的代理。',
        cancel: '取消',
        confirm: '確定'
      },
      addAgent: {
        title: '添加為代理',
        commissionSettings: '設定返傭比例',
        confirm: '添加為代理'
      },
      remark: {
        title: '編輯備註',
        label: '備註',
        placeholder: '請輸入備註',
        confirm: '儲存備註'
      },
      details: {
        title: '基本資訊',
        spot: '現貨返傭比例',
        futures: '合約返傭比例',
        alpha: 'Alpha返傭比例',
        customerType: '客戶類型',
        directClient: '直接客戶',
        indirectClient: '間接客戶',
        superiorAgentUID: '上級代理UID',
        group: '分組名稱',
        none: '無',
        registrationTime: '註冊時間'
      }
    },
    clientGroup: {
      title: '客戶分組',
      dataUpdatedAt: '資料更新於：{time}（UTC+8 時區）',
      groupName: '分組名稱',
      pleaseEnterGroupNamePlaceholder: '請輸入分組名稱',
      creationTime: '創建時間',
      queryTime: '查詢時間',
      startTime: '開始時間',
      endTime: '結束時間',
      totalRecords: '條記錄',
      selected: '已選擇',
      of: '共',
      items: '項',
      none: '無',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      createSuccess: '創建成功。',
      createError: '創建時出錯。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      table: {
        dataList: '資料列表',
        addGroup: '添加分組',
        groupId: '分組ID',
        groupName: '分組名稱',
        creationTime: '創建時間',
        memberCount: '分組人數',
        spotRatio: '現貨返傭比例',
        futuresRatio: '合約返傭比例',
        depositorCount: '入金人數',
        totalDeposit: '累計入金(USDT)',
        totalVolume: '累計交易量(USDT)',
        totalCommission: '累計返傭(USDT)',
        operation: '操作',
        manage: '管理',
      },
      create: {
        addTitle: '添加新分組',
        manageTitle: '管理分組',
        groupName: '分組名稱',
        groupNameMaxLength: '最多 12 個字元',
        commissionSettings: '設定返傭比例',
        spot: '現貨',
        futures: '合約',
        alpha: 'Alpha',
        clientRatio: '客戶的比例',
        myRatio: '我的的比例',
        newUser: '新使用者',
        selected: '已選擇',
        people: '人',
        notAvailable: '不可用',
        pleaseEnterCustomerUID: '請輸入客戶UID',
        noMember: '未選擇任何成員',
        cancel: '取消',
        confirm: '確認'
      }
    },
    superAgent: {
      title: '超級代理系統',
      dataUpdatedAt: '資料更新於：{time}（UTC+8 時區）',
      superAgentUID: '超級代理UID',
      pleaseEnterPlaceholder: '請輸入',
      customerGroup: '客戶分組',
      transactionTime: '交易時間',
      startTime: '開始時間',
      endTime: '結束時間',
      reset: '重設',
      query: '查詢',
      all: '全部',
      none: '無',
      of: '共',
      items: '項',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      createSuccess: '創建成功。',
      createError: '創建時出錯。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      table: {
        superAgentUID: '超級代理UID',
        timeToBecomeSuperAgent: '入駐時間',
        invitationCode: '邀請碼',
        registrationTime: '註冊時間',
        totalInvites: '總邀請人數',
        agentCount: '代理人數',
        rebateRatio: '返傭比例',
        operation: '操作',
        manage: '管理'
      },
      manage: {
        addTitle: '添加超級代理',
        manageTitle: '修改超級代理',
        UID: 'UID',
        username: '使用者名稱',
        usernamePlaceholder: '設定使用者名稱或備註',
        commissionSettings: '設定傭金比例',
        spot: '現貨',
        futures: '合約',
        alpha: 'Alpha',
        clientRatio: '客戶的比例',
        myRatio: '我的的比例',
        cancel: '取消',
        confirm: '確認'
      }
    }
  },
  invitationPromotion: {
    invitationLink: {
      title: '邀請連結',
      dataUpdatedAt: '資料更新時間：{time}（UTC+8 時區）',
      searchQuery: '搜尋查詢',
      code: '邀請碼',
      pleaseEnterPlaceholder: '請輸入邀請碼或備註',
      promotionChannel: '推廣管道',
      all: '全部',
      dataStatisticsTime: '資料統計時間',
      startTime: '開始時間',
      endTime: '結束時間',
      reset: '重設',
      query: '查詢',
      totalRecords: '條記錄',
      selected: '已選擇',
      of: '共',
      items: '項',
      none: '無',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      table: {
        code: '邀請碼',
        default: '預設連結',
        custom: '自訂註冊頁',
        spot: '現貨返傭比例',
        futures: '合約返傭比例',
        alpha: 'Alpha返傭比例',
        linkLocation: '連結定位',
        clickCount: '點擊數',
        registrationCount: '註冊人數',
        depositCount: '入金人數',
        tradeCount: '交易人數',
        tradingVolume: '交易量(USDT)',
        rebateAmount: '返傭金額(USDT)',
        operation: '操作',
        settings: '設定',
        shareLink: '分享連結',
      },
      share: {
        title: '邀請好友',
        yourCode: '您的邀請碼是',
        whatsapp: 'WhatsApp',
        line: 'LINE',
        telegram: 'Telegram',
        twitter: 'Twitter',
        facebook: 'Facebook',
        shareMessage: '邀請好友加入 QuBit，賺取獎勵',
        copySuccess: '連結已複製到剪貼簿',
        copySuccessMsg: '連結已複製到剪貼簿',
        copyFailed: '複製連結失敗',
        copyFailedMsg: '複製連結失敗，請手動複製',
        bindSuccess: '綁定成功',
        bindFailed: '綁定邀請碼失敗',
        requestFailed: '請求失敗',
        shareTitle: '分享邀請連結'
      },
      settings: {
        title: '連結詳情',
        invitationLink: '邀請連結',
        spot: '現貨',
        futures: '合約',
        alpha: 'Alpha',
        web3: 'Web3',
        link: '邀請連結',
        code: '邀請碼',
        registrationType: '註冊頁類型',
        remarks: '備註',
        remarksPlaceholder: '請輸入備註',
        dataOverview: '資料概覽',
        rebateAmount: '返傭金額(USDT)',
        tradingVolume: '交易量(USDT)',
        numberOfClicks: '點擊數',
        numberOfInvites: '邀請人數',
        numberOfTraders: '交易人數',
        numberOfDepositors: '入金人數',
        modifyRebateRatio: '修改返傭比例',
        changeInvitationCode: '更換邀請碼',
        editRegistrationType: '編輯註冊頁類型',
        customRegistrationPage: '自訂註冊頁',
        notSelected: '未選擇',
        cancel: '取消',
        confirm: '確認'
      }
    },
    registration: {
      title: '自訂註冊頁',
      create: '創建註冊頁',
      edit: '編輯註冊頁',
      totalRecords: '條記錄',
      selected: '已選擇',
      of: '共',
      items: '項',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      table: {
        name: '註冊頁名稱',
        validity: '頁面有效時間',
        to: '至',
        creationTime: '頁面創建時間',
        linkCount: '邀請連結數',
        profileInfo: '個人資訊',
        status: '狀態',
        default: '預設註冊頁',
        operation: '操作',
        edit: '編輯',
        yes: '是',
        no: '否'
      },
      custom: {
        title: '創建註冊頁',
        name: '註冊頁名稱',
        registrationPageNamePlaceholder: '請輸入註冊頁名稱',
        showPersonalInfo: '顯示個人資訊',
        hidePersonalInfo: '隱藏個人資訊',
        upload: '上傳',
        namePlaceholder: '請輸入姓名',
        introduction: '簡介',
        introductionPlaceholder: '請輸入不超過 100 個漢字或 200 個英文字元。',
        recommendedImageMaterials: '推薦圖片素材',
        default: '預設',
        noImage: '無圖片',
        platformStrength: '平台實力',
        transactionRebate: '交易返傭',
        manyBenefits: '多重福利',
        thoughtfulService: '貼心服務',
        eventImage: '活動圖片',
        recommendedSize: '（推薦：560 * 300）',
        validity: '頁面有效期（兩選一）',
        longTermEffective: '長期有效',
        customTime: '自訂時間',
        start: '開始時間',
        end: '結束時間',
        eventLink: '活動連結',
        eventLinkPlaceholder: '請輸入',
        cancel: '取消',
        create: '創建',
        confirm: '確認'
      }
    },
    review: {
      title: '操作記錄',
      dataUpdatedAt: '資料更新時間：{time}（UTC+8 時區）',
      customerUID: '客戶UID',
      pleaseEnterPlaceholder: '請輸入客戶UID',
      type: '類型',
      invitationLink: '邀請連結',
      reset: '重設',
      query: '查詢',
      add: '添加代理',
      modify: '修改代理',
      groupUpsert: '分組更新',
      groupMemberUpsert: '分組成員更新',
      topAgentAdd: '添加頂級代理',
      all: '全部',
      totalRecords: '條記錄',
      selected: '已選擇',
      of: '共',
      items: '項',
      none: '無',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      walletAddressError: '請輸入數字客戶UID。',
      customerUIDNumericError: '客戶UID只能包含數字。',
      invalidCustomerUID: '無效的客戶UID格式。',
      table: {
        submissionTime: '提交時間',
        customerUID: '客戶UID',
        type: '類型',
        spot: '現貨返傭比例',
        futures: '合約返傭比例',
        alpha: 'Alpha返傭比例',
        confirmationTime: '確認時間',
        status: '狀態',
        reason: '失敗原因',
        operation: '操作',
        viewDetails: '查看詳情'
      }
    }
  },
  financialDetails: {
    commission: {
      title: '傭金明細',
      dataUpdatedAt: '資料更新時間：{time}（UTC+8 時區）',
      customerUID: '客戶UID',
      customerPlaceholder: '請輸入客戶UID',
      orderID: '訂單ID',
      orderIDPlaceholder: '請輸入訂單ID',
      rebateType: '返傭類型',
      all: '全部',
      transactionTime: '交易時間',
      startTime: '開始時間',
      endTime: '結束時間',
      tradingPair: '交易對',
      transactionMethod: '交易方式',
      buy: '買入',
      sell: '賣出',
      reset: '重設',
      query: '查詢',
      none: '無',
      cumulativeCommission: '累計返傭',
      spot: '現貨',
      futures: '合約',
      alpha: 'Alpha',
      of: '共',
      items: '項',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      exportSuccess: '資料匯出成功！',
      noDataToExport: '沒有可匯出的資料。',
      exportError: '匯出失敗。請再試一次。',
      table: {
        customerUID: '客戶UID',
        remark: '備註',
        orderID: '訂單ID',
        customerGroup: '客戶分組',
        associatedAgent: '關聯代理',
        superiorAgentUID: '上級代理UID',
        tradingPair: '交易對',
        rebateRate: '返傭比例',
        rebateAmount: '返傭金額',
        rebateTime: '返傭時間',
        transactionMethod: '交易方式',
        depositStatus: '入帳狀態',
      },
      depositStatusOptions: {
        unsettled: '未結算',
        pending: '待發放',
        completed: '已發放',
        cancelled: '已取消',
        frozen: '凍結發放'
      },
      rebateOptions: {
        spot: '現貨',
        futures: '合約',
        alpha: 'Alpha'
      }
    },
    transaction: {
      title: '交易明細',
      dataUpdatedAt: '資料更新時間：{time}（UTC+8 時區）',
      customerUID: '客戶UID',
      customerPlaceholder: '請輸入客戶UID',
      superiorAgentUID: '上級代理UID',
      superiorAgentPlaceholder: '請輸入上級代理UID',
      tradingPair: '交易對',
      all: '全部',
      groupName: '分組名稱',
      default: '預設',
      role: '角色',
      maker: 'Maker',
      taker: 'Taker',
      transactionTime: '交易時間',
      startTime: '開始時間',
      endTime: '結束時間',
      transactionMethod: '交易方式',
      buy: '買入',
      sell: '賣出',
      reset: '重設',
      query: '查詢',
      none: '無',
      cumulativeTradingVolume: '累計交易量（USDT）',
      cumulativeTransactionFees: '累計手續費（USDT）',
      spot: '現貨',
      futures: '合約',
      alpha: 'Alpha',
      of: '共',
      items: '項',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      exportSuccess: '資料匯出成功！',
      noDataToExport: '沒有可匯出的資料。',
      exportError: '匯出失敗。請再試一次。',
      table: {
        customerUID: '客戶UID',
        remark: '備註',
        orderID: '訂單ID',
        email: '信箱',
        handlingFee: '手續費',
        group: '分組',
        superiorAgentUID: '上級代理UID',
        transactionTime: '交易時間',
        tradingPair: '交易對',
        transactionVolume: '交易量',
        netFee: '淨手續費',
        transactionMethod: '交易方式',
        operationAmount: '操作金額'
      }
    },
    daily: {
      title: '每日資料彙總',
      dataUpdatedAt: '資料更新時間：{time}（UTC+8 時區） *T+1後更新數據',
      timeRange: '時間範圍',
      startTime: '開始時間',
      endTime: '結束時間',
      none: '無',
      of: '共',
      items: '項',
      copySuccess: '複製成功。',
      copyError: '複製錯誤。',
      fetchError: '獲取資料時發生錯誤。',
      groupFetchError: '獲取分組列表時發生錯誤。',
      modifyDirectOnly: '您只能修改直接客戶的客戶比例。',
      modifyRatioIncreaseOnly: '您只能增加比例。',
      modifySuccess: '儲存成功。',
      modifyError: '修改時出錯。',
      exportSuccess: '資料匯出成功！',
      noDataToExport: '沒有可匯出的資料。',
      exportError: '匯出失敗。請再試一次。',
      table: {
        date: '日期',
        totalCommission: '總返傭',
        totalTransactionAmount: '總交易金額',
        netHandlingFee: '淨手續費',
        newInvitedPeopleCount: '新增邀請人數'
      }
    }
  }
}
